// import 'core-js'
// import 'react-app-polyfill/stable'
// import { createRoot } from 'react-dom/client'
// import { Provider } from 'react-redux'
// import App from './App'
// import store from './store'
// const container = document.getElementById('root')

// const root = createRoot(container) // createRoot(container!) if you use TypeScript
// root.render(
//   <Provider store={store}>
//     <ThemeProvider>
//       <App />
//     </ThemeProvider>
//   </Provider>,
// )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// NOTE: below code was added when switched to vite from CRA

// CRITICAL: Import React first to ensure it's initialized before Emotion/MUI
// This prevents "Cannot access uninitialized variable" errors in production builds
// The order matters: React must be imported before any components that use Emotion
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { ThemeProvider } from './context/ThemeContext'
import store from './store'
import { loadCSSForRoute } from './utils/cssLoader'

// CRITICAL: Force React module initialization by accessing useInsertionEffect
// This ensures React is fully loaded before any Emotion code tries to access it
// This prevents "Cannot access uninitialized variable" errors in production builds
// when chunks load asynchronously and Emotion chunk might execute before React chunk
// This is a safeguard - accessing the property ensures the module is fully initialized
const _reactInitialized = React && typeof React.useInsertionEffect !== 'undefined' ? React.useInsertionEffect : null

// CRITICAL: Ensure ReactDOM is fully initialized before react-redux tries to access it
// This prevents "Cannot read properties of undefined (reading 'unstable_batchedUpdates')" errors
// React 18 doesn't have unstable_batchedUpdates, but react-redux should handle this gracefully
// However, we need to ensure ReactDOM is loaded before react-redux executes
// Accessing ReactDOM.createRoot ensures the module is fully initialized
if (typeof ReactDOM === 'undefined' || typeof ReactDOM.createRoot === 'undefined') {
  throw new Error('ReactDOM is not properly initialized')
}

// import 'core-js'
// import 'react-app-polyfill/stable'

// Hide initial loader once React has rendered AND app data is loaded
// Use multiple strategies to ensure it works
function hideInitialLoader() {
  const loader = document.getElementById('initial-loader')
  if (loader) {
    loader.classList.add('hidden')
    if (document.body) {
      document.body.classList.add('react-loaded')
    }
  }
}

function InitialLoaderDismissSignal() {
  React.useEffect(() => {
    let animationFrameId = 0
    let nestedAnimationFrameId = 0

    animationFrameId = window.requestAnimationFrame(() => {
      nestedAnimationFrameId = window.requestAnimationFrame(() => {
        hideInitialLoader()
      })
    })

    return () => {
      window.cancelAnimationFrame(animationFrameId)
      window.cancelAnimationFrame(nestedAnimationFrameId)
    }
  }, [])

  return null
}

async function bootstrapApp() {
  try {
    await loadCSSForRoute(window.location.pathname || '/')
  } catch (error) {
    console.warn('[main] Failed to preload route-specific CSS:', error)
  }

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <InitialLoaderDismissSignal />
          <div className="Root">
            <App />
          </div>
        </ThemeProvider>
      </Provider>
    // </React.StrictMode>,
  )
}

bootstrapApp()
